// extracted by mini-css-extract-plugin
export default {"topBarHeight":"56px","green":"#0b0"};